import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import './index.css'
import App from './App.tsx'

/** Salida de emergencia: novaberry.pages.dev/?limpiar=1
 *
 *  Deja el navegador como recién instalado —service worker, cachés y
 *  datos locales— antes de que la app llegue siquiera a arrancar. Sirve
 *  para el caso en que un service worker viejo quedó atascado sirviendo
 *  archivos de dos versiones distintas: ahí la app ni alcanza a
 *  dibujarse, así que ningún botón dentro de la app puede salvarla.
 *  Es un link que se puede mandar por WhatsApp y listo. */
if (new URLSearchParams(location.search).has('limpiar')) {
  document.body.innerHTML =
    '<div style="font:600 16px system-ui;display:grid;place-items:center;height:100dvh;color:#1b5e37">Limpiando…</div>'
  void (async () => {
    try {
      if ('serviceWorker' in navigator) {
        const registros = await navigator.serviceWorker.getRegistrations()
        await Promise.all(registros.map((r) => r.unregister()))
      }
      if ('caches' in window) {
        const claves = await caches.keys()
        await Promise.all(claves.map((k) => caches.delete(k)))
      }
      localStorage.clear()
      sessionStorage.clear()
    } finally {
      // Con "recien" el navegador no puede reutilizar nada suyo, y sin
      // el "limpiar" no vuelve a entrar en este mismo camino.
      location.replace(`/?recien=${Date.now()}`)
    }
  })()
  throw new Error('limpiando')
}

// Antes esto lo dejaba el plugin con un registro "mudo" (registerSW.js)
// que solo instalaba el service worker nuevo pero nunca avisaba a la
// pestaña abierta para que lo usara — por eso los cambios no se veían
// hasta cerrar la app del todo y volver a abrirla. Con registerType
// "autoUpdate" y este registro, apenas hay una versión nueva se activa
// y la página se recarga sola, sin que nadie tenga que hacer nada.
if ('serviceWorker' in navigator) {
  // Cuando el service worker nuevo toma el control de una pestaña que
  // ya estaba abierta, esa pestaña tiene cargado el JavaScript viejo
  // pero de ahí en adelante recibe los archivos nuevos: media versión
  // de cada una, que es justo lo que reventaba con "x is not a
  // function". Recargar una sola vez la deja entera en la versión
  // nueva. El candado evita el bucle si el navegador dispara el evento
  // más de una vez.
  let recargando = false
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (recargando) return
    recargando = true
    window.location.reload()
  })

  registerSW({
    immediate: true,
    onRegisteredSW(_url, registration) {
      if (!registration) return
      // Por si alguien deja la app abierta muchas horas seguidas: revisa
      // cada 30 minutos si salió una versión nueva.
      setInterval(() => registration.update(), 30 * 60 * 1000)
    },
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
